import axios from 'axios';
import type { IRecentSearchHistory } from '@bb/domain/dist/types';

const clearHistory = async (type: 'listing' | 'agent') => {
  const { data } = await axios.delete<IRecentSearchHistory>(`/search/recents`, {
    params: { type },
  });
  return data;
};

export default clearHistory;
